import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { ProductService } from 'src/app/content-source/shopify-product/product.service';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-feature',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgClass,
    NgIf,
    NgFor,
    StoryblokDirective,
    CarouselComponent,
    DynamicModule,
  ],
  templateUrl: './feature.component.html',
  styleUrl: './feature.component.scss',
})
export class FeatureComponent implements OnChanges {
  @Input() assets!: any;
  @Input() image!: any;
  @Input() image_mobile!: any;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() disable_variant_filter: boolean = false;

  components: any;
  _selected: any;
  _assets: any;
  _selectedVariant: any;
  _variantMode: boolean = false;

  constructor(private productService: ProductService) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  select(blok: any) {
    this._selected = structuredClone(blok._uid);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.assets?.length > 0 && !this.disable_variant_filter) {
      this.productService.variantObservable.subscribe((data: any) => {
        this._selectedVariant = data;
        const found = this.assets.find((asset: any) => {
          if (!asset.image.filename) {
            return false;
          }
          const check = this.cleanText(
            asset.image.filename
              .split('/')
              [asset.image.filename.split('/').length - 1].split('-')
              .join(' ')
              .replaceAll('_', '-')
              .toLowerCase()
          );
          const title = this.cleanText(
            this._selectedVariant.title.toLowerCase()
          );
          return check.includes(title);
        });
        if (found) {
          this._variantMode = true;
          this._assets = this.assets.filter((asset: any) => {
            const check = this.cleanText(
              asset.image.filename
                .split('/')
                [asset.image.filename.split('/').length - 1].split('-')
                .join(' ')
                .replaceAll('_', '-')
                .toLowerCase()
            );
            const title = this.cleanText(
              this._selectedVariant.title.toLowerCase()
            );
            return check.includes(title);
          });
        }
      });
    }
    for (let entry of this.assets) {
      entry.aspect_ratio = entry.aspect_ratio ? entry.aspect_ratio : 126;
      entry.width = 1000;
      entry.height = 650;
      entry.style = 'fill';
      entry.aspect_ratio = (1000 / 650) * 100;
    }
  }

  cleanText(text: string): string {
    // Remove special characters
    text = text.replace(/[^A-Za-z0-9\s]/g, '');
    // Reduce multiple spaces to a single space
    text = text.replace(/\s+/g, ' ');
    // Trim leading and trailing spaces
    text = text.trim();
    return text;
  }

  options = {
    0: { slides: 1, nav: true },
  };
}
